export class AdsBannerLogic extends PIXI.utils.EventEmitter {
    public isBannerVisible: boolean = false;
    private _bannerRefreshTime: number = 60;// seconds

    private _bannerRefreshIntervalId: number = -1;

    constructor() {
        super();

        window.addEventListener('resize', () => {
            this.onResize()
        });
    }

    private onResize(): void {
        const isCanView = false;//window.innerWidth > 975 && window.innerHeight > 560;

        // TODO: хардкод - убрать
        const el = document.getElementById('banner-container');
        if (this.isBannerVisible) {
            if (!isCanView && el.style.visibility !== 'hidden') {
                el.style.visibility = 'hidden';
            } else if (isCanView && el.style.visibility !== 'visible') {
                el.style.visibility = 'visible';
            }
        }
    }

    public clearAllBanners(): void {
        this.isBannerVisible = false;
        this.stopBannerRefresh();
        this.removeAllListeners('adUpdate');
    }

    public clearBanner(containerId: string =  'banner-container'): void {
        try {
            const el = document.getElementById(containerId);
            if (el) {
                el.style.visibility = 'hidden';
            }
        } catch (e) { }

        this.isBannerVisible = false;
        this.stopBannerRefresh();
    }

    public showBanner(containerId: string = 'banner-container'): void {
        return;
        try {
            const el = document.getElementById(containerId);
            if (el) {
                el.style.visibility = 'visible';
                this.startBannerRefresh();

                this.isBannerVisible = true;
            }
        } catch (e) { }
    }

    private startBannerRefresh(): void {
        this.stopBannerRefresh();

        this._bannerRefreshIntervalId = setInterval(() => {
                this.emit('adUpdate');
            }, this._bannerRefreshTime * 1000) as any;
    }

    private stopBannerRefresh(): void {
        console.log('stopBannerRefresh', this._bannerRefreshIntervalId)

        if (this._bannerRefreshIntervalId) {
            clearInterval(this._bannerRefreshIntervalId);
            this._bannerRefreshIntervalId = -1;
        }
    }
}